import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router'
import { signOut } from '../actions/users'
import * as API from '../utility/api'
import AdminShell from '../components/admin-console/admin-shell'
import Stats from '../components/admin-console/stats'
import Exports from '../components/admin-console/exports'
import Tools from '../components/admin-console/tools'
import { unhandledOverpaidCount } from '../components/admin-console/overpaid'
import BasketManagement from '../components/admin-console/basket-management'
import SepaPage from '../components/admin-console/sepa-page'
import UsersManagement from '../components/admin-console/users-management'
import TicketsManagement from '../components/admin-console/tickets-management'
import Translations from '../components/admin-console/translations'
import TestPage from '../components/admin-console/test-page'
import SearchAlerts from '../components/admin-console/search-alerts'
import LoginModal from './login-modal'
import GlobalNotification from './global-notification'

const PAGE_HEADS = {
  statistiikka: null,
  raportit: {
    title: 'Raportit',
    subtitle: 'Myynti- ja velkaraportit järjestäjittäin, tapahtumittain ja myyjittäin.'
  },
  sepa: {
    title: 'SEPA ja tilitykset',
    subtitle: 'Tilitysaineistot järjestäjille ja myyjille.'
  },
  tyokalut: {
    title: 'Työkalut',
    subtitle: 'Poikkeamat ja manuaaliset korjaukset.'
  },
  liput: {
    title: 'Liput',
    subtitle: 'Hae ja hallinnoi yksittäisiä lippuja.'
  },
  tilaukset: {
    title: 'Tilaukset',
    subtitle: 'Hae tilauksia ja avaa jumittuneet kassat.'
  },
  asiakkaat: {
    title: 'Asiakasrekisteri',
    subtitle: 'Hae asiakkaita ja vie rekisteri.'
  },
  kaannokset: {
    title: 'Käännökset',
    subtitle: 'Muokkaa sivuston tekstejä kielittäin.'
  },
  sahkopostivahdit: {
    title: 'Sähköpostivahdit',
    subtitle: 'Aktiiviset lippuvahdit.'
  },
  testi: {
    title: 'Testi',
    subtitle: 'Sisäinen testinäkymä.'
  }
}

const pageKeyFromPath = pathname => {
  const parts = (pathname || '').split('/').filter(Boolean)
  return parts[1] || 'statistiikka'
}

const AdminConsole = ({ match, location, userInfo, dispatch }) => {
  const [overpaidCount, setOverpaidCount] = useState(0)
  const pageKey = pageKeyFromPath(location && location.pathname)
  const pageHead = PAGE_HEADS[pageKey]
  const userName = [userInfo && userInfo.first_name, userInfo && userInfo.last_name]
    .filter(Boolean)
    .join(' ')

  const pathname = location && location.pathname

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  useEffect(() => {
    let cancelled = false

    API.GET('admin/tools/tickets_overpaid')
      .then(({ data }) => {
        if (cancelled) {
          return
        }
        setOverpaidCount(unhandledOverpaidCount(data && data.tickets))
      })
      .catch(error => {
        if (API.isHandledAuthError(error) || cancelled) {
          return
        }
        setOverpaidCount(0)
      })

    return () => {
      cancelled = true
    }
  }, [])

  const handleOverpaidChange = useCallback(tickets => {
    setOverpaidCount(unhandledOverpaidCount(tickets))
  }, [])

  const handleLogout = () => {
    dispatch(signOut())
  }

  return (
    <React.Fragment>
      <LoginModal />
      <GlobalNotification />
      <AdminShell
        title={pageHead && pageHead.title}
        subtitle={pageHead && pageHead.subtitle}
        userName={userName || 'Admin'}
        onLogout={handleLogout}
        badges={{ tyokalut: overpaidCount }}
      >
        <Switch>
          <Route path={`${match.path}/statistiikka`} component={Stats} />
          <Route path={`${match.path}/raportit`} component={Exports} />
          <Route path={`${match.path}/sepa`} component={SepaPage} />
          <Route
            path={`${match.path}/tyokalut`}
            render={() => (
              <Tools onOverpaidChange={handleOverpaidChange} />
            )}
          />
          <Route path={`${match.path}/liput`} component={TicketsManagement} />
          <Route path={`${match.path}/tilaukset`} component={BasketManagement} />
          <Route path={`${match.path}/asiakkaat`} component={UsersManagement} />
          <Route path={`${match.path}/kaannokset`} component={Translations} />
          <Route path={`${match.path}/sahkopostivahdit`} component={SearchAlerts} />
          <Route path={`${match.path}/testi`} component={TestPage} />
          <Redirect to={`${match.path}/statistiikka`} />
        </Switch>
      </AdminShell>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  userInfo: state.users.userInfo
})

export default connect(mapStateToProps)(AdminConsole)
